// extracted by mini-css-extract-plugin
export var emailBlockLink = "_or-0";